<template>
    <div>
        <div class="shadow relative overflow-hidden sm:rounded-md">
            <div v-if="loading">
                <div class="absolute w-full h-full bg-black opacity-40"></div>
                <div class="absolute w-full h-full flex">
                    <div class="m-auto">
                        <i class="fas fa-spinner text-white fa-spin fa-3x my-1"></i>
                    </div>
                </div>
            </div>

            <div class="px-4 py-5 bg-white sm:p-6">
                <div class="grid grid-cols-6 gap-6">
                    <div class="col-span-6 sm:col-span-3">
                        <TextInput
                            label="First name"
                            name="first_name"
                            v-model="first_name"
                            autocomplete="given-name"
                        ></TextInput>
                    </div>

                    <div class="col-span-6 sm:col-span-3">
                        <TextInput
                            label="Last name"
                            name="last_name"
                            :validation="v$.last_name"
                            v-model="last_name"
                            autocomplete="family-name"
                        ></TextInput>
                    </div>

                    <div class="col-span-6 sm:col-span-3">
                        <TextInput
                            label="Email address"
                            name="email"
                            :validation="v$.email"
                            v-model="email"
                            autocomplete="email"
                        ></TextInput>
                    </div>

                    <div class="col-span-6 sm:col-span-3">
                        <TextInput
                            label="Phone"
                            name="phone"
                            v-model="phone"
                            autocomplete="telephone"
                        ></TextInput>
                    </div>
                </div>
            </div>
            <div class="px-4 py-3 bg-gray-50 text-right sm:px-6">
                <button
                    v-on:click="onSubmit"
                    class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-ap-primary hover:bg-ap-primary-darkened focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                    Update
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import useVuelidate from '@vuelidate/core';
import { email, required, helpers } from '@vuelidate/validators';
import TextInput from '../TextInput.vue';

const { withMessage } = helpers;

export default {
    setup() {
        return {
            v$: useVuelidate(),
        };
    },
    data() {
        return {
            loading: false,
            first_name: this.authCustomer.first_name,
            last_name: this.authCustomer.last_name,
            email: this.authCustomer.email,
            phone: this.authCustomer.phone,
        };
    },
    validations() {
        return {
            last_name: {
                required: withMessage('Last name is required', required),
            },
            email: {
                required: withMessage('Email address is required', required),
                email: withMessage('Not a valid email', email),
            },
        };
    },
    props: {
        authCustomer: {
            type: Object,
            required: false,
        },
    },
    methods: {
        async onSubmit() {
            const result = await this.v$.$validate();

            if (!result) {
                return false;
            }

            this.loading = true;
            axios.post('/account/details/update', {
                first_name: this.first_name,
                last_name: this.last_name,
                email: this.email,
                phone: this.phone,
            }).then((response) => {
                this.loading = false;
                this.showAlert(response.data.message);
            }).catch((err) => {
                this.loading = false;
                this.showAlert('There was an error', false);
            });

            return true;
        },
        showAlert(message, isSuccess) {
            this.$emit('show-alert', {
                message,
                isSuccess,
            });
        },
    },
    components: {
        TextInput,
    },
}
</script>
